/**
 * S3 Helper functions
 * */

import { GetObjectCommandOutput, GetObjectCommand, HeadObjectCommand, HeadObjectCommandOutput, S3Client } from "@aws-sdk/client-s3";

/**
 * Get a File from S3
 * */
const getObjectBlob = async(s3Client: S3Client, bucket: string, key: string): Promise<Blob> => {

    const command = new GetObjectCommand({
        Bucket: bucket,
        Key: key
    });

    const response = await s3Client.send(command);
    if (!response.Body) throw new Error('File not found or empty on the Bucket.');

    return await convertObjectToBlob(response); 
}

/**
 * Get head from a S3 file
 * */
const getObjectHead = async(s3Client: S3Client, bucket: string, key: string): Promise<HeadObjectCommandOutput> => {
    
    const command = new HeadObjectCommand({
        Bucket: bucket,
        Key: key
    });

    const response = await s3Client.send(command);
    if (!response) throw new Error('File not found on the Bucket.');

    return response; 
}

const convertObjectToStream = (response: GetObjectCommandOutput) => {
    return response.Body as ReadableStream;
  };

const convertObjectToBlob = async (response: GetObjectCommandOutput) => {
    return await new Response(convertObjectToStream(response)).blob();
};

  
export { getObjectBlob, convertObjectToBlob, convertObjectToStream, getObjectHead };